import { render, staticRenderFns } from "./OneCamConfigDialog.vue?vue&type=template&id=8a95da04&scoped=true"
import script from "./OneCamConfigDialog.vue?vue&type=script&lang=js"
export * from "./OneCamConfigDialog.vue?vue&type=script&lang=js"
import style0 from "./OneCamConfigDialog.vue?vue&type=style&index=0&id=8a95da04&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a95da04",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8a95da04')) {
      api.createRecord('8a95da04', component.options)
    } else {
      api.reload('8a95da04', component.options)
    }
    module.hot.accept("./OneCamConfigDialog.vue?vue&type=template&id=8a95da04&scoped=true", function () {
      api.rerender('8a95da04', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/master/systemconfig/OneCamConfigDialog.vue"
export default component.exports